module.exports = __webpack_public_path__ + "img/kosuzu motoori.d6ad51fd.png";